import apiRequest from './index'

export default {
  path: '/v1/carwash/ss/__SSCODE__/prepaidCards/normalTrialCharge',

  async post (authid, ssCode, data) {
    await window.callNativeHTTPX()
    return apiRequest.post(this.path.replace(/__SSCODE__/g, ssCode), { ...data }, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-AUTH-ID': authid
      }
    })
  }
}
